<template>
  <div class="scrap_editResults_dialog">
    <custom-dialog width="1180px" :title="model.title" :visible="visible" v-on="$listeners">
      <div class="dialog-body">
        <div class="item-title-info">
          <custom-table :data="list" tableCode="scrapRecord_approval"  :slots="['returnType','action']" height="300px">
            <template slot="returnType" slot-scope="scope">
              <custom-select v-model="scope.row.returnType" code="dms_scrap_return_type" width="100%" :placeholder="$t('Common.com_please_select')" :clearable="false" ></custom-select>
            </template>
            <template slot="action">
              <el-button type="text" size="mini" @click="deleteBtn(index)">
                {{$t('Common.com_delete')}}
              </el-button>
            </template>
          </custom-table>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="visible = false">{{ $t('Common.com_cancel') }}</el-button>
        <el-button type="primary" @click="confirm">{{ $t('Common.com_confirm')}}</el-button>
      </div>
    </custom-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';

export default {
  mixins: [dialogMixins],

  data() {
    return {
      list: [],
    };
  },
  mounted() {
    this.initDialog();
  },
  methods: {
    // 初始化
    initDialog: function () {
      this.list = this.model.data;
    },
    deleteBtn(index) {
      this.list.splice(index, 1);
    },
    // 保存新增
    confirm: function () {
      const hasEmpty = this.list.find(
        t => t.applyDesc === ''
      );
      if (hasEmpty) {
        const tips = this.$t('dms_scrap_editResults_dialog.qxzspjg');
        this.$message.error(tips);
        return;
      }
      this.$postJSON(apis.DeviceScrapSetReturnTypeBatch, this.list).then(() => {
        this.$message({
          message: this.$t('Common.com_handle_success'),
          type: 'success'
        });
        this.$emit('success');
        this.visible = false;
      });
    }
  }
};
</script>
